// admin.regions.tsx — T094 (2/5)
// Route : /admin/regions

import { createFileRoute } from "@tanstack/react-router";

import { AdminRegionsPage } from "@/presentation/pages/AdminRegionsPage";

export const Route = createFileRoute("/admin/regions")({
  component: AdminRegionsPage,
});
